"use strict";

exports.__esModule = true;
exports.addPromo = void 0;
/* eslint-disable import/prefer-default-export */

var addPromo = function addPromo(value) {
  return {
    type: 'ADD_PROMO',
    value: value
  };
};
exports.addPromo = addPromo;